import React from 'react';
import cd from 'debug';
import { API, View } from '@gin-betting/core';

import { MarketTitle } from 'components';
import { getSignedSpecifierPair } from 'utils';
import { MarketHcpRow } from '../MarketHcpRow';
import useUserMarket from './useUserMarket';
import useRemoveUserMarkets from './useRemoveUserMarkets';
import { getHcpSpecifier } from '../MarketsValue/utils';
import { TITLES_BY_SPECIFIER } from 'app-constants';
import './MarketHcp.scss';

const debug = cd('match-list:components:MarketHcp');

export interface OwnProps {
    market: View.Market;
    hasMatchHeader?: boolean;
    // getCustomMarketMatches: () => void;
    // matchId: string;
    isDefaultName?: boolean;
}

type Props = OwnProps;

export const MarketHcp: React.FC<Props> = props => {
    debug('render', props);
    const {
        market,
        hasMatchHeader,
        // getCustomMarketMatches,
        // matchId,
        isDefaultName,
    } = props;

    const { id: topMarketId } = market;

    const userMarket = useUserMarket({ topMarketId });

    const resultMarket = userMarket || market;

    const {
        specifiers,
        name,
        odds,
        // id,
        // typeId
    } = resultMarket;

    const specifier = getHcpSpecifier(specifiers);

    const [firstValue, secondValue] = getSignedSpecifierPair(
        specifier ? specifier.value : null
    );

    // useRemoveUserMarkets(topMarketId);

    return (
        <div styleName="container" className="__app-MarketHcp-container ">
            {hasMatchHeader && (
                <MarketTitle
                    name={isDefaultName ? '' : name}
                    defaultMsg={TITLES_BY_SPECIFIER.handicap}
                />
            )}
            <MarketHcpRow
                // topMarketId={topMarketId}
                // marketType={typeId}
                oddId={odds[0]}
                // matchId={matchId}
                value={firstValue}
                // getCustomMarketMatches={getCustomMarketMatches}
                // selectedMarketId={id}
                // isAway={false}
            />
            <MarketHcpRow
                // topMarketId={topMarketId}
                // marketType={typeId}
                oddId={odds[1]}
                // matchId={matchId}
                value={secondValue}
                // getCustomMarketMatches={getCustomMarketMatches}
                // selectedMarketId={id}
                // isAway={true}
            />
        </div>
    );
};

const defaultProps: Required<Pick<Props, 'market'>> = {
    market: {
        id: '',
        priority: 0,
        status: API.MarketStatus.SUSPENDED,
        odds: ['', ''],
        name: '',
        specifiers: [],
        typeId: -999,
        tags: [],
    },
};

MarketHcp.defaultProps = defaultProps;

export default React.memo(MarketHcp);
